import { useEffect, useCallback } from "react";
import { successLicnece, sendLicenceAction } from "../Actions/BuildingManagementAction";

export const useAutoFocus = (openModal, firstInputRef) => {
  useEffect(() => {
    const timeoutId = setTimeout(() => {
      if (openModal && firstInputRef.current) {
        firstInputRef.current.focus();
      }
    }, 200);

    return () => clearTimeout(timeoutId);
  }, [openModal, firstInputRef]);
};

export const useHandleClose = (dispatch, setOpenModal, sendLicenceSuccess) => {
  return useCallback(() => {
    setOpenModal(false);
    if (sendLicenceSuccess) {
      dispatch(successLicnece());
    }
  }, [dispatch, setOpenModal, sendLicenceSuccess]);
};

export const useHandleSave = (dispatch, licenseData) => {
  return useCallback(() => {
    dispatch(sendLicenceAction(licenseData));
  }, [dispatch, licenseData]);
};

export const handleModalCloseEvent = (event, reason, tooltipOpen, setTooltipOpen, handleClose) => {
  if (reason === "escapeKeyDown") {
    if (tooltipOpen) {
      setTooltipOpen(false);
    } else {
      handleClose();
    }
  } else if (reason === "backdropClick") {
    return;
  }
};
